import { Injectable } from "@angular/core";



@Injectable()
export class HubSpotWidgetService {
  private hubspotWidgetOpen = false;


  public createWidget(): void {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = "//js-eu1.hs-scripts.com/144565796.js";
    var div = document.createElement("div")
    div.id = 'hubspot-placeholder'
    document.body.append(div)
    document.addEventListener("click", (e:any)=> {
      if(e.target && e.target.id != 'hubspot-placeholder' && e.target.id != 'help-button') {
        console.log('clicked on hubspot widget')
        const hubspot:HTMLElement = document.querySelector('#hubspot-placeholder')
        if(hubspot) {
          console.log('clicked on hubspot widget');
          hubspot.style.display = "none";
          this.closeWidget();
          this.hubspotWidgetOpen = false;
      }
    }});
    const w  = window as any
    w.hsConversationsSettings = {
      loadImmediately: false,
      inlineEmbedSelector:  '#hubspot-placeholder'
    };
    w.hsConversationsOnReady = [() => {
      console.log('HubSpot chat widget loaded');
    }]
    document.body.append(script);   
  }

  public openWidget(): void {
    const w  = window as any
    w.HubSpotConversations.widget.load();
    w.HubSpotConversations.widget.open();
  }

  public closeWidget(): void {
    const w  = window as any
    w.HubSpotConversations.widget.remove();
  }


  public getStatus(): any {
    const w  = window as any
    return w.HubSpotConversations.widget.status()
  }

  public showPlaceholder(): void {
    const hubspot:HTMLElement = document.querySelector('#hubspot-placeholder')
    if(hubspot) {
      hubspot.style.display = "block";
    }
  }

  public hidePlaceholder(): void {
    const hubspot:HTMLElement = document.querySelector('#hubspot-placeholder')
    if(hubspot) {
      hubspot.style.display = "none";
    }
  }

  public toggleWidget(): void {
    if (this.hubspotWidgetOpen) {
      this.closeWidget();
      this.hubspotWidgetOpen = false;
      this.hidePlaceholder();
    } else {
      this.openWidget();
      this.hubspotWidgetOpen = true;
      this.showPlaceholder();
    }
  }
}
